<div class="flex-column gap-l">
    <ng-container *ngIf="!openSubcontainer">
        <dashlet-section-processor-memory
            #processorMemory
            [showSystemChart]="dashlet.showSystemChart"
            [showDiskUsage]="dashlet.showFileSystem"
            [equipment]="dashlet.equipment"
            [customerId]="dashlet.customer.customerId"
            [locationId]="dashlet.location.locationId"
            [commandTypeIdCPUUsage]="dashlet.commandTypeIdCpu"
            [commandTypeIdMemoryUsage]="dashlet.commandTypeIdMemory"
            [commandTypeIdUpTime]="dashlet.commandTypeIdServer"
            [commandTypeIdDiskUsage]="dashlet.commandTypeIdFileSystem"
        >
        </dashlet-section-processor-memory>

        <!-- network connectivity -->
        <dashlet-section-network-connectivity
            [showNetworkGraph]="dashlet.showNetworkGraph"
            [equipment]="dashlet.equipment"
            [customerId]="dashlet.customer.customerId"
        >
        </dashlet-section-network-connectivity>

        <div *ngIf="dashlet.showDatabaseSummary" class="section section-services">
            <dashlet-section-header>Database Summary</dashlet-section-header>
            <div class="justify-space-between grow">
                <div class="flex-column gap-s mat-h2 metric" [ngStyle]="{ 'border-left-color': getDatabaseColor(dashlet.databaseSummaryTally) }">
                    <div class="mat-caption">Replication Status</div>
                    <div >{{ dashlet.databaseSummaryTally ? dashlet.databaseSummaryTally.Replicate_State : '-' }}</div>
                </div>
                <div class="flex-column gap-s mat-h2 metric">
                    <div class="mat-caption">Replicates Created</div>
                    <div class="text-right">{{ dashlet.databaseSummaryTally ? dashlet.databaseSummaryTally.NumberofReplicatesCreated : '-' }}</div>
                </div>
            </div>
        </div>
    </ng-container>
    <dashlet-section-network-interface
        *ngIf="dashlet.showNetworkInterface"
        [equipment]="dashlet.equipment"
        [locationName]="dashlet.location.locationName"
        [customerName]="dashlet.customer.customerName"
        (openDetails)="$event ? openDetails($event) : closeDetails()"
    ></dashlet-section-network-interface>
</div>
